module.exports = __webpack_public_path__ + "static/media/signup.f7548fb1.jpg";